import lodash from 'lodash';
import {AppState} from '../store';

export const getExchangeRate = (state: AppState) => state.exchangeRate;

export const getExchangeRateBuyPrice = (state: AppState) =>
  state.exchangeRate.data?.buyPrice;

export const getExchangeRateBacking = (state: AppState) => {
  const backing = state.exchangeRate.data?.backing;
  return !lodash.isNil(backing) ? `${backing * 100}%` : 'Unknown';
};
